<div class="log-box shadow p-3 mb-5 bg-white rounded">
    <h4 class="text-center">Event Log</h4>
    <table class="table">
        <tr><td class="font-weight-bold">Simulation State: </td><td>{{ simStateName }}</td></tr>
        <tr *ngIf="simState == 0"><td class="font-weight-bold">Average Node Degree: </td><td>{{ curNodeDegree }}</td></tr>
        <tr><td class="font-weight-bold">Messages in Circulation: </td><td>{{ numMsgsInCirculation }}</td></tr>
    </table>

</div>